<template>
  <div
    class="relative"
    v-if="display"
    tabindex="-1"
    @blur="showActions = false"
  >
    <div
      class="rounded py-2 flex justify-center items-center cursor-pointer"
      @click="showActions = !showActions"
    >
      <p class="text-deepBlue">Bulk Action</p>
      <span class="pl-2"
        ><svg
          width="10"
          height="5"
          viewBox="0 0 10 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0L5 5L10 0H0Z" fill="#10233E" />
        </svg>
      </span>
    </div>
    <div class="options rounded" v-if="showActions">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["display"],
  data() {
    return {
      showActions: false,
    };
  },
};
</script>

<style scoped>
.options {
  position: absolute;
  cursor: pointer;
  top: 3rem;
  min-width: 10rem;
  background: #ffffff;
  font-size: 0.9rem;
  padding: 0.25rem;
}
</style>
